import {LogoBrand} from './LogoBrand.tsx';
import {Contours} from './Ornaments.tsx';
import {ChipTone, type BankCardSkin} from './types.ts';

function Face() {
    return (
        <>
            <div className="absolute inset-0 bg-[linear-gradient(165deg,#FBFBF9_0%,#EFF0EC_60%,#E6E7E2_100%)]" />
            <Contours color="#2F8455" opacity={0.1} />
        </>
    );
}

export const abnAmroSkin: BankCardSkin = {
    Face,
    Brand: LogoBrand,
    chipTone: ChipTone.Gold,
    hasMastercard: true,
    surfaceTone: 'light',
    contentColor: '#23252B',
    labelColor: '#7A7D76',
    contactlessColor: '#8A8D88',
    mastercardWordColor: '#3A3A36',
};
